import PropTypes from 'prop-types'
import React, { Component } from 'react'

class EditButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hover: this.props.hover
        }

        this.fill = this.fill.bind(this)
        this.visibility = this.visibility.bind(this)
    }

    fill() {
        if (this.state.hover)
            return this.props.hoverColor
        return this.props.color
    }

    visibility() {
        if (this.props.parentHover)
            return 'visible'
        return 'hidden'
    }

    render() {
        return (
            <div
                title="Edit"
                style={{
                    visibility: this.visibility(),
                    background: 'none',
                    float: 'right',
                    width: '36px',
                    height: '36px',
                    border: 'none',
                    padding: '6px',
                    cursor: 'pointer',
                    pointerEvents: 'visible'
                }}
                onClick={this.props.onClick ?
                    (e) => this.props.onClick(this.props.index, e) : null
                }
                onMouseOver={(e) => this.setState({ hover: true })}
                onMouseOut={(e) => this.setState({ hover: false })}>
                <svg
                    fill={this.fill()}
                    height="24"
                    viewBox="-7.5 -3 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg">

                    <path d="M 9.324219 2.527344 L 12.375 5.578125 L 4.652344 13.300781 L 1.605469 10.25 Z M 14.691406 1.792969 L 13.332031 0.429688 C 12.804688 -0.09375 11.953125 -0.09375 11.421875 0.429688 L 10.121094 1.734375 L 13.171875 4.785156 L 14.691406 3.265625 C 15.097656 2.855469 15.097656 2.199219 14.691406 1.792969 Z M 0.0078125 14.539062 C -0.046875 14.789062 0.179688 15.011719 0.429688 14.949219 L 3.828125 14.125 L 0.777344 11.074219 Z M 0.0078125 14.539062 " />
                </svg>
            </div>
        )
    }
}

EditButton.propTypes = {
    index: PropTypes.number,
    color: PropTypes.string,
    parentHover: PropTypes.bool,
    hover: PropTypes.bool,
    hoverColor: PropTypes.string,
    onClick: PropTypes.func
}

EditButton.defaultProps = {
    parentHover: false,
    hover: false
}

export default EditButton
